import * as React from 'react'
import styles from './JoePompSection.module.scss'
import ImageBackground from 'components/ImageBackground'
import { ScreenBreakPoint } from 'constants/index'
import AnchorLink from 'react-anchor-link-smooth-scroll'
import cx from 'classnames'

const bg_set = [
	{
		url: 'https://eightsleep.imgix.net/mobile_hero_movie_bg.png?v=1614260617',
		breakpoint: '0px',
		x: 750, // width of image
		y: 1200, // height of image
	},
	{
		url: 'https://eightsleep.imgix.net/hero_movie_bg_857135cc-bb0d-45a2-baef-83ad408ed332.png?v=1614260643',
		breakpoint: ScreenBreakPoint.sm + 'px',
		x: 750, // width of image
		y: 300, // height of image
	},
	{
		url: 'https://eightsleep.imgix.net/hero_movie_bg_857135cc-bb0d-45a2-baef-83ad408ed332.png?v=1614260643',
		breakpoint: ScreenBreakPoint.md + 'px',
		x: 1800,
		y: 700,
	},
]

const JoePompSection: React.SFC<any> = () => {
	return (
		<>
			<ImageBackground
				bgSet={bg_set}
				className="home-hero-bg-img"
			>
				<div className={styles.tim_ferriss_container}>
					<h1 className={styles.tim_ferriss_title}>"As someone who has always struggled with sleep, the Pod Pro Cover has been a game changer. It's amazing"</h1>
					{/* <p className={styles.tim_ferriss_description}></p> */}
					{/* <p className={styles.tim_ferriss_description_second}>- Joe Pompliano</p> */}
					<AnchorLink
						offset="115"
						href="#main_shop"
						className={cx(styles.tim_ferriss_button, 'btn-lnk')}
						aria-label={'Shop the cover'}
					>
						Get the cover
					</AnchorLink>
				</div>
			</ImageBackground>
		</>
	)
}

export default JoePompSection
